import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar = ({ show, toggle }) => {

    return (
        <>
            <div className={`th-menu-wrapper onepage-nav ${show ? 'th-body-visible' : ''}`}>
                {/* <div className="th-menu-wrapper onepage-nav active"> */}
                <div className="th-menu-area text-center">
                    <button className="th-menu-toggle" onClick={toggle}>
                        <i className="fal fa-times" />
                    </button>
                    <div className="mobile-logo">
                        <Link to="/" onClick={toggle}>
                            <img src="/assets_web/img/logo/delight_logo.jpg" alt="Delight" />
                        </Link>
                    </div>
                    <div className="th-mobile-menu">
                        <ul>
                            <li onClick={toggle}>
                                <Link to="/">Home</Link>
                            </li>
                            <li onClick={toggle}>
                                <Link to="/about-us">About Us</Link>
                            </li>
                            <li onClick={toggle}>
                                <Link to="/contact-us">Contact Us</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sidebar
